<template>
  <div class="connect-with-us">            
    <mdb-dropdown tag="li">
      <mdb-dropdown-toggle tabindex="0" tag="a" slot="toggle" class="connectwithus-widget dropdown-toggle">
        <img :src="'/img/material-widgets.png'" alt="" class="img-connect"/>
        <span >{{languageData['connect_with_us']}}</span>
        </mdb-dropdown-toggle>
      <mdb-dropdown-menu class="drop-nav">
        <a v-if="!scheduler_flag" class="drop-item" v-on:click.stop.prevent="callscheduler()" href="#">
          <img alt="Scheduler" :src="LOCAL_HOST+'/img/scheduler_ico.png'" class="item-img"/>
          <div class="scheduler_span">{{languageData['schedule_an_appointment']}}</div>
          <img :src="LOCAL_HOST+'/img/right_arrow.png'" alt="" class="img-arrow">
        </a>
        <a v-if="themeLogic.headers.live_connect" class="drop-item" v-on:click.stop.prevent="openNewWindow()" href="#"> 
          <img alt="live connect chat with us" :src="LOCAL_HOST+'/img/live_connect_cosmic23x20.png'" class="item-img">
          <div >{{languageData['chat']}}</div>
          <img :src="LOCAL_HOST+'/img/right_arrow.png'" alt="" class="img-arrow">
        </a>
        <a v-if="themeLogic.additional_flag.raise_an_issue_form" class="drop-item" href="/feedback/"> 
          <img :src="'/img/cross_icon.png'" alt="" class="item-img">
          <div >{{languageData['concern_form']}}</div>
          <img :src="LOCAL_HOST+'/img/right_arrow.png'" alt="" class="img-arrow">
        </a>
        <template v-for="(connect,ky) in connect_us">
          <a class="drop-item" v-if="connect['url_external']=='0' && connect['open_new_window'] == '0'" :href="LOCAL_HOST+connect['url']" :key="ky">
            <img :src="connect['iconImg']" :alt="languageData[connect['title']]" class="item-img">
            <div >{{languageData[connect['title']]}}</div>
            <img :src="LOCAL_HOST+'/img/right_arrow.png'" alt="" class="img-arrow">
          </a>
          <a class="drop-item" v-if="connect['url_external']=='0' && connect['open_new_window'] == '1'" :href="LOCAL_HOST+connect['url']" target="_blank">
            <img :src="connect['iconImg']" :alt="languageData[connect['title']]" class="item-img">
            <div >{{languageData[connect['title']]}}</div>
            <img :src="LOCAL_HOST+'/img/right_arrow.png'" alt="" class="img-arrow">
          </a>
          <a class="drop-item" v-if="connect['url_external']=='1' && connect['open_new_window'] == '0'" :href="connect['url']">
            <img :src="connect['iconImg']" :alt="languageData[connect['title']]" class="item-img">
            <div >{{languageData[connect['title']]}}</div>
            <img :src="LOCAL_HOST+'/img/right_arrow.png'" alt="" class="img-arrow">
          </a>
          <a class="drop-item" v-if="connect['url_external']=='1' && connect['open_new_window'] == '1'" :href="connect['url']" target="_blank">
            <img :src="connect['iconImg']" :alt="languageData[connect['title']]" class="item-img">
            <div >{{languageData[connect['title']]}}</div>
            <img :src="LOCAL_HOST+'/img/right_arrow.png'" alt="" class="img-arrow">
          </a>
          <div id="qaltrics_popup"><!--DO NOT REMOVE-CONTENTS PLACED HERE--></div>

        </template>
      </mdb-dropdown-menu>
    </mdb-dropdown>
  </div>

</template>

<script>
import axios from 'axios';
 import {  mdbNavbarToggler, mdbDropdown, mdbDropdownMenu, mdbDropdownToggle } from 'mdbvue';


export default {
    name: 'ConnectwithUs',
    data(){
        return{
          CONTENT_DOMAIN:this.$store.state.CONTENT_DOMAIN, 
          LOCAL_HOST:this.$store.state.LOCAL_HOST,
          lang_id:localStorage.id_language,
          scheduler_flag:0,
          ucms_id_scheduler:this.$store.state.companyDataInfo.ucms_company,
          not_inAppointmentType:[],
          availabilityInfoMessage:"",
          company_data:[],
          connect_us: []
        };
    },
     components: {
             mdbNavbarToggler, 
             mdbDropdown, 
             mdbDropdownMenu, 
             mdbDropdownToggle 
        }, 
    computed:{
      languageData(){return this.$store.state.languageData;},
      themeLogic(){return this.$store.state.themeLogic;},
      companyDataInfo(){return this.$store.state.companyDataInfo},
      liveConnectCsAr(){ if(this.lang_id=='043') {return ' live-connect-cs-ar'}else{return '';}},
      schedulerCsAr(){ if(this.lang_id=='043') {return ' scheduler-cs-ar'}else{return '';}}
    },
    mounted: function () {
      if(this.$store.state.companyDataInfo['id_customizations']=="" || this.$store.state.companyDataInfo['id_customizations']==undefined || this.$store.state.companyDataInfo['id_customizations']=='undefined'){
          this.getCompanyData();
      }else{
          this.company_data['id_customizations']=this.$store.state.companyDataInfo['id_customizations'];
          this.schedulerCheck();
      } 
      this.connectusCheck();   
    },
    created:function(){
          
    },
	  methods:{      
      openNewWindow:function(){
          var link='https://rms.workplaceoptions.com/anonymouschat/'+this.companyDataInfo['rms_system']+"/"+this.companyDataInfo['rms_company']+"/"+this.companyDataInfo['rms_service']+"/"+this.companyDataInfo['id_language_rms']+"?id_company="+this.$store.state.companyData['id_company']+"&name_company="+this.$store.state.companyData['name_company'];
          //console.log("getting here"+screen.width+'-h-'+screen.height);             
          window.open(link,'menu', 'location');                
      },
      callscheduler(o,t){
          //console.log('not_inAppointmentType-',this.ucms_id_scheduler);
          window.psObject.initProviderScheduler({
              position:"bottom-right",
              providerName:o,
              providerAddress:t,
              ucmsCompanyId:this.ucms_id_scheduler,
              notInAppointmentType:this.not_inAppointmentType,
              availabilityInfoMessage:this.availabilityInfoMessage,
              websiteId:this.$store.state.companyData['id_company'],
              webLanguageId:this.$store.state.companyData['id_language'],
              webCountryId:this.$store.state.companyData['id_country']
          })
      },
      getCompanyData(){        
          var api_private_key=this.get_api_key_mix('cofo')
          axios.get(this.$store.state.apiUrl+'/company_info',{
              params:{
                  id_company:this.$store.state.companyData['id_company'] ,
                  id_language:this.$store.state.companyData['id_language'],
                  id_country:this.$store.state.companyData['id_country'],                    
                  privatekey:api_private_key
                  }
              })
          .then(response => {
              response = response.data;
              this.company_data['id_customizations'] = response['id_customizations'];
              this.schedulerCheck();          
              })
          .catch((error) => {
              this.company_data = [];
              this.company_data['id_customizations']=this.$store.state.companyDataInfo['id_customizations'];
              this.schedulerCheck(); 
              this.customErrorHandler(error.response.status);
              });
      },
      schedulerCheck(){
          axios.get(this.$store.state.apiUrl+'/scheduler_widget_config',{
              params:{
                  id_language:this.$store.state.companyData['id_language'],
                  id_eap:this.$store.state.companyData['id_eap'],
                  id_company:this.$store.state.companyData['id_company'],
                  id_country:this.$store.state.companyData['id_country'],
                  id_customization:this.company_data['id_customizations']
              }
          })
          .then(response => {
              response = response.data;
              this.scheduler_flag = response.flag;
              if(response.ucms_id!=""){
                  this.ucms_id_scheduler=response.ucms_id;
              }
              this.not_inAppointmentType=response.not_in_appointment_type;
              this.availabilityInfoMessage=response.availabilityInfoMessage;
          })
          .catch(() => {
              //console.log('sched-err-came-custID:',this.company_data['id_customizations']);
              this.scheduler_flag = 0;
          });
      },
      connectusCheck(){
          var api_private_key=this.get_api_key_mix('geig') 
          axios.get(this.$store.state.apiUrl+'/get_connect_panel_config',{
              params:{
                  id_language:this.$store.state.companyData['id_language'],
                  id_eap:this.$store.state.companyData['id_eap'],
                  id_company:this.$store.state.companyData['id_company'],
                  id_country:this.$store.state.companyData['id_country'],
                  privatekey:api_private_key
              }
          })
          .then(response => {
              this.connect_us = response.data;
          })
          .catch(() => {
              //console.log('sched-err-came-custID:',this.company_data['id_customizations']);
              this.connect_us = [];
          });
      }
     
    }
};
</script>
<style scoped>


@media only screen  and (min-width : 992px) {
.side {
    margin-bottom: 0 !important;
    }
}
.parent {
  width: 90%;
  float: right;
  background: #02437d;
  padding: 10px 8px 1px 8px;
  border-radius: 12px;
}
@media only screen and (max-width: 1280px) and (min-width: 993px) {
  .parent {
    width: 100% !important;
}
}
@media only screen and (max-width: 992px) and (min-width: 768px){
  .parent {
    width: 100% !important;
  }  
}
@media only screen and (max-width: 767px) and (min-width: 576px) {
 
  .parent {
    width: 100% !important;
  }
}
@media only screen and (max-width: 576px) { 
  .parent {
    width: 100% !important;
  }
}
.connectwithus-widget{
  display: block;
  height: 40px;
  background:#0F2D59;
  /* background-image: url('/img/material-widgets.png'); */
  background-repeat: no-repeat;
  background-position: 20px 10px;
  color: #FFF;
  min-width: 200px;
  float: right;
  margin-top: 16px;
  border-radius: 0;
  margin-top: 20px;
}
.img-connect {
  padding-right: 10px;
}
.connect-with-us {
  margin-top: 20px;
}
.dropdown-toggle::after {
    display: none !important;
  }
 :focus {
    outline: none !important;
    border: none !important;
    outline-offset: none !important;
  }
  .drop-nav {
    min-width: 340px;
    padding: 17px;
    left: -137px;
  }
  .drop-item {
    position: relative;
    padding: 7px 0;
    display: flex;
    align-items: center;
  }
  .img-arrow {
    position: absolute;
    right: 0;
    top: 15px;
  }
  .item-img {
    padding-right: 15px;
    /* width: 20px; */
    height: 20px;
  }
@media only screen and (max-width: 400px)   {
  .drop-nav {
    min-width: 277px;
    padding: 17px;
    left: -33px;
  }
}
@media only screen and (max-width: 576px) and (min-width: 401px)  {
  .drop-nav {
    left: -137px;
  }
}

.scheduler-cs{
    background: linear-gradient(0deg, rgba(2,0,36,0) 11%, rgb(250 250 250) 9%, rgb(255 255 255 / 94%) 73%, rgba(0,212,255,0) 99%);
    margin-right: 16px;
    overflow: hidden;
}
.scheduler-cs .scheduler_ico{
    width:64px !important;
}
.scheduler-normal .scheduler_ico{
    width: 35px !important;
    float: none;
}
.scheduler-cs .scheduler_span{
    width: 120px;
    display: inline-block;
    text-align: left;
    padding-bottom: 0px;
    vertical-align: middle;
    font-weight: bold;
    font-size: 14px;
    color: #676767;
    letter-spacing: .1em;
    line-height: 21px;
    font-family: 'Roboto';
    text-shadow: 1px 0 0 #494949;
}
.scheduler-normal .scheduler_span{
    width: 125px;
    display: inline-block;
    vertical-align: top;
    /* font-weight: bold; */
    font-size: 12px;
    color: #676767;
    letter-spacing: .1em;
    /* line-height: 1.2em; */
    font-family: 'Roboto';
    text-shadow: 1px 0 0 #494949;
} 
.scheduler-cs button{
    left: -2px !important;
    top: -30px !important;
}
.live-connect-cs{
    position: fixed !important;
    bottom: 35px !important;
    right: 35px !important;
}

.live-connect-cs-ar{   
    left: 1px !important;
    right: unset !important;
}

.live-connect-normal img{
    width: 115px !important;
}
.live-connect-normal:after{
    height: 0px !important;
}
.scheduler-normal img{
    width: 120px !important;
    float: left;
}
.scheduler-normal:after{
    height: 0px !important;
}
.live-connect-cs:after{
    height: 0px !important;   
}
.scheduler-cs:after{
    height: 0px !important;   
}
.live-connect-cs button{
    width: 16px !important;
    height: 15px !important;
    padding: 0 0 0 0px;    
    position: relative;    
    z-index: 999999;
    left: -18px;
    top: -25px;
    border: none;
    line-height: 1px;
    font-size: 10px;
    font-weight: bold;
    border-radius: 6px;
    color: #616161e6;
    background: #f8f8f8e8;
}
.scheduler-cs button{
    width: 16px !important;
    height: 15px !important;
    padding: 0 0 0 0px;    
    position: relative;    
    z-index: 999999;
    left: -18px;
    top: -25px;
    border: none;
    line-height: 1px;
    font-size: 10px;
    font-weight: bold;
    border-radius: 6px;
    color: #616161e6;
    background: #f8f8f8e8;
}
.live-connect-cs img{
   /* background:linear-gradient(0deg, rgba(2,0,36,0) -17%, rgb(250 250 250) 15%, rgb(255 255 255 / 94%) 29%, rgba(0,212,255,0) 99%);
   width: 200px; */
}
.scheduler-cs img{
   /* background:linear-gradient(0deg, rgba(2,0,36,0) -17%, rgb(250 250 250) 15%, rgb(255 255 255 / 94%) 29%, rgba(0,212,255,0) 99%); */
    background: linear-gradient(0deg, rgba(2,0,36,0) -17%, rgb(250 250 250) 15%, rgb(255 255 255 / 94%) 51%, rgba(0,212,255,0) 100%);
    width: 200px;
}
.scheduler-cs{
    position: fixed !important;
    bottom: 130px !important;/* 95px */
    right: 35px !important;
}
.scheduler-cs-ar{   
    left: 1px !important;
    right: unset !important;
    float: right !important;
}
scheduler-cs.scheduler-cs-ar .scheduler_span{
    float: left !important;
}
.live-connect-cs img {
    background: -webkit-gradient(linear, left bottom, left top, color-stop(-17%, rgba(2,0,36,0)), color-stop(1%, rgb(250 250 250)), color-stop(29%, rgb(255 255 255 / 94%)), color-stop(99%, rgba(0,212,255,0)));
    background: linear-gradient(0deg, rgba(2,0,36,0) -17%, rgb(250 250 250) 2%, rgb(255 255 255 / 94%) 29%, rgba(0,212,255,0) 99%);
    width: 200px;
}
.liveconnect-text{
    color: #015595; /* #424242; */
    position: absolute;
    top: 10;
    bottom: -16px;
    background: #f9f9f9;
    width: 200px;
    font-size: 14px;
    font-weight: bold;
    padding: 1px 8px 0 0;
}
.live-connect-normal .liveconnect-text{
    display: none;
}
.report-an-issue-lnk{
    color: white;
    background: #17629c;
    font-weight: bold;
    font-size: 13px;
    padding: 10px;
    border-radius: 5px;
}
.connect-with-us>li>span, .dropdown-toggle:focus {
    
      color: #ffff !important;
          outline: 2px dotted #e9f8ff !important;
    border: none;
    outline-offset: -1px !important;
 
  }
  .dropdown-toggle:hover {
    text-decoration: none !important;
    color: #ffff !important;
  }
  .dropdown-toggle:focus {
    border: none !important;
  }
  .drop-item div{
    max-width: 250px;
  }
</style>